<ng-container [formGroup]="form">
  <input
    class="form-control"
    [id]="id"
    [placeholder]="placeholder !== false ? ($any(placeholder) | translate) : ''"
    autocomplete="off"
    formControlName="number"
    portalInputValidityState
    type="text"
  />

  @if (form.get('number').pending) {
    <div class="text-info mt-1">
      <i class="far fa-circle-notch fa-spin me-1"></i>
      <span>{{ 'numberEvaluator.evaluating' | portalTranslate }}</span>
    </div>
  }

  @if (evaluatedNumber != null) {
    <div class="text-info mt-1">
      @if (evaluatedNumber.ndc) {
        {{ 'numberEvaluator.evaluatedTo' | portalTranslate: evaluatedNumber }}
      } @else {
        {{ 'numberEvaluator.evaluatedTo.emptyNdc' | portalTranslate: evaluatedNumber }}
      }
    </div>
  }
</ng-container>
